import React from "react";

export default function SignUp(props) {
    const currentUrl = window.location.href;
    const signUpUrl = `${props.signUpUrl}?${props.returnUrlKey}=${encodeURIComponent(currentUrl)}`;
    const signInUrl = `${props.signInUrl}?${props.returnUrlKey}=${encodeURIComponent(currentUrl)}`;

    return (
        <div className="d-flex flex-column h-100 align-items-center justify-content-center save-search-popup-body">
            <div className="icon" />
            <h3>{props.translations.headerText}</h3>
            <p>{props.translations.bodyText}</p>
            <a className="btn btn-primary" href={signUpUrl}>
                {props.translations.signUp}
            </a>
            <div className="login">
                {props.translations.member} <a href={signInUrl}>{props.translations.signIn}</a>
            </div>
        </div>
    );
}